






import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class CollectMushrooms extends Vue {
  type: GameType = GameType.COLLECTMUSHROOMS;
  title = views.find((el) => el.component === GameType.COLLECTMUSHROOMS).title;
  video = "normalto.mp4";
}
